module.exports = __webpack_public_path__ + "img/video-image@3x.1df12185.png";